function addToCart(id,qty){
  console.log(id)
  formData = {
    'items': [
      {
        'id': id,
        'quantity': qty
      }
    ]
  };
  var ser = 'id=' + id + '&quantity=' + qty
  console.log(ser)
  $.ajax({
    url: "/cart/add.js",
    dataType: 'json',
    type: 'POST',
    data: ser,
    success: function(itemData) {
      console.log('bien')
      tata.success("", "Producto añadido.", {
        duration: 2000,
        animate: "slide",
      });
      jQuery.getJSON('/cart.js', function(cart) {
        $('#cart_count').text(cart.item_count)
      } );
    },
    error: function(XMLHttpRequest) {
      console.log('mal')
    }
  });
}

$(document).ready(function(){
  $('#recovery_password').on('click', function(){
        $('#recovery_password_section').toggleClass('d-none')
        $('#login_section').toggleClass('d-none')
    })
    $('#login_button').on('click', function(){
        $('#recovery_password_section').toggleClass('d-none')
        $('#login_section').toggleClass('d-none')
    })
  var cen = 0
  $('.filter-cb-wrap').on("click", function(){
    if(cen == 0){
    let value = $(this).attr('value')
    let group = $(this).attr('group')
    let btn = $('.filter-cb.'+value)
      let text = $('.filter-cb-label.'+value+group)
    $('.filter-cb.'+group).each(function(){
      if($(this) != btn && $(this).hasClass('w--redirected-checked')){
        $(this).removeClass('w--redirected-checked')
      }
    })
    $('.filter-cb-label.'+group).each(function(){
      if($(this) != text){
        $(this).css('color','rgb(37,138,232)')
      }
    })
      console.log($('.filter-cb-label.'+value+group))
    $('.filter-cb-label.'+value+group).css('color','#fff')
      cen = 1
    }
    else{
      cen = 0
    }
  })
})

function addressModal(value){
  if($('#modal_99'+value).hasClass('d-none')){
    $('#modal_99'+value).removeClass('d-none')
  }
  else{
    $('#modal_99'+value).addClass('d-none')
  }
}

function reviewsModal(){
  if($('#reviews_modal').hasClass('d-none')){
    $('#reviews_modal').removeClass('d-none')
  }
  else{
    $('#reviews_modal').addClass('d-none')
  }
}

function plus(id){
  $('#qty_'+id).text(parseInt($('#qty_'+id).text()) + 1)
}
function minus(id){
  if($('#qty_'+id).text() > 1){
  $('#qty_'+id).text(parseInt($('#qty_'+id).text()) - 1)
  }
}



